import { isObject, arrayOrEmpty, numberOrNull } from './helpers';

/* ============================================================
   GALLERY MEDIA - FRONTEND -> BACKEND
============================================================ */

export function transformMedia(media = []) {
    return arrayOrEmpty(media)
        .map((item, index) => {
            if (typeof item === 'string') {
                return {
                    url: item,
                    type: 'image',
                    category: 'other',
                    sortOrder: index,
                    isCover: index === 0
                };
            }

            if (!isObject(item)) {
                return null;
            }

            if (!item.url) {
                return null;
            }

            return {
                _id: item._id || undefined,

                url: item.url,

                thumbnailUrl: item.thumbnailUrl || '',

                type: item.type === 'video' ? 'video' : 'image',

                category: item.category || 'other',

                caption: item.caption || item.title || '',

                altText: item.altText || item.alt || '',

                sortOrder: numberOrNull(item.sortOrder ?? item.order) ?? index,

                // the chosen cover; the first photo when none is marked
                isCover: item.isCover === true || (index === 0 && !media.some((m) => m?.isCover === true))
            };
        })
        .filter(Boolean);
}

/* ============================================================
   GALLERY MEDIA - BACKEND -> FRONTEND
   ------------------------------------------------------------
   MediaSection reads formData.media as an array of
   { url, category, alt, title, order } objects (its own
   normalizeMedia() re-shapes anything else on mount anyway),
   so this is close to a straight pass-through - just renaming
   caption/altText/sortOrder back to title/alt/order.
============================================================ */

export function reverseMedia(media = []) {
    return arrayOrEmpty(media).map((item, index) => ({
        _id: item?._id,
        url: item?.url || '',
        category: item?.category || 'other',
        alt: item?.altText || item?.alt || '',
        title: item?.caption || item?.title || '',
        order: numberOrNull(item?.sortOrder) ?? index,
        // kept as saved
        isCover: Boolean(item?.isCover),
        type: item?.type === 'video' ? 'video' : 'image',
        thumbnailUrl: item?.thumbnailUrl || ''
    }));
}

/* ============================================================
   CARD IMAGES - FRONTEND -> BACKEND
============================================================ */

export function transformCardImages(images = []) {
    return arrayOrEmpty(images)
        .map((image) => {
            if (typeof image === 'string') {
                return image;
            }

            if (isObject(image)) {
                return image.url || image.src || '';
            }

            return '';
        })
        .filter(Boolean);
}

/* ============================================================
   PAYMENT OPTIONS - FRONTEND -> BACKEND
============================================================ */

export function transformPaymentOptions(payment = {}) {
    return {
        cashAtProperty: Boolean(payment.cashAtProperty ?? payment.payAtProperty),

        onlinePayment: payment.onlinePayment !== false,

        partialPayment: Boolean(payment.partialPayment)
    };
}

/* ============================================================
   PAYMENT OPTIONS - BACKEND -> FRONTEND
============================================================ */

export function reversePaymentOptions(payment = {}) {
    return {
        onlinePayment: payment?.onlinePayment !== false,
        payAtProperty: Boolean(payment?.cashAtProperty),
        partialPayment: Boolean(payment?.partialPayment)
    };
}
